import {
  GET_USER_PREMIUM_STATUS_COMPLETE,
  GET_STRIPE_DETAILS_COMPLETE,
  GET_STRIPE_PLANS_COMPLETE
} from '../actions/types';

const INITIAL_STATE = {
  user_premium: null,
  premium_source: undefined,
  current_period_end: undefined,
  nickname: null,
  stripe_plans_dict: {},
  sources: [],
  stripe_plans_dict_by_name: {}
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_USER_PREMIUM_STATUS_COMPLETE:
      return { ...state,
        user_premium: action.payload.premium,
        premium_source: action.payload.source,
        current_period_end: action.payload.current_period_end
      };
    case GET_STRIPE_DETAILS_COMPLETE:
      return { ...state,
        nickname: action.payload.nickname,
        sources: action.payload.sources,
        default_source: action.payload.default_source
      };
    case GET_STRIPE_PLANS_COMPLETE:
      let stripePlansDict = {};
      let stripePlansDictByName = {};

      for (let value of action.payload) {
        stripePlansDict[value.plan_id] = value;
      }
      for (let value of action.payload) {
        stripePlansDictByName[value.nickname] = value;
      }
      return {
        ...state,
        stripe_plans_dict: stripePlansDict,
        stripe_plans_dict_by_name: stripePlansDictByName
      };
    default:
      return state;
  }
}
